export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'Channel Link ID: ',
    },
    store_id: {
      label: 'External location id: ',
    },
    store_provisioning_url: {
      label: 'Store provisioning URL: ',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    error: 'Failed to save changes',
    success: 'Changes got saved',
  },
  instructions: {
    title: 'Setup instructions:',
    step_1:
      'Open the <Link>"Locations"</Link> page in Deliverect, expand the proper location and click on the "+ Channel link" button.',
    step_2: 'Fill in the necessary info. On the "Select your online delivery platform" step select "Food Amigos".',
    step_3: 'Finish all the steps. Then, on the "Locations" page, click on "Edit" on the "Food Amigos" channel.',
    step_4: 'In the sidebar click on the "Channel connection" tab and fill in these details:',
    step_5: 'Save the changes by clicking on the "Save" button at the top right.',
    step_6: 'Once saved, click on the "More" icon at the top right, then on "Register" and after that on "Activate".',
    step_7: 'Go back to the "General" tab, switch the "Integration status" to "Active" and save the changes.',
    outro: 'After that you can push the menu from Deliverect and create a test order.',
  },
  connected: {
    title: 'Deliverect is connected',
    description: 'This integration is set up.',
  },
};
